<app-statistik-netomsla-options (periodeChange)="onPeriodeChange($event)"
                                (selectYear)="onYearSelected($event)"
                                [periode]="periode"
                                class="d-flex"></app-statistik-netomsla-options>
<div>
    <table class="table table-hover table-striped table-sm table-frame__body">
        <thead class="fixed-top position-fixed position-sticky">
            <tr>
                <th> LA</th>
                <ng-container *ngFor="let IndexCard of laCards">
                    <th class="text-end">{{IndexCard.fornavn}} {{IndexCard.efternavn}}</th>
                </ng-container>
                <th class="text-end">Total</th>
            </tr>
        </thead>

        <tbody>
            <tr class="item__tr">
                <td>Faktureret i perioden</td>
                <ng-container *ngFor="let IndexCard of laCards">
                    <td class="text-end">{{getFakturaForPeriode(fakturaer, IndexCard.cardId) |
                        currency:'DKK':'':'1.0-0':'da'}}</td>
                </ng-container>
                <td class="text-end">{{(fakturaer | StatistikNetomslaPipe:'beloeb') | currency:'DKK':'':'1.0-0':'da' }}
                </td>
            </tr>

            <tr class="item__tr">
                <td>Igang Primo</td>
                <ng-container *ngFor="let IndexCard of laCards">
                    <td class="text-end">{{getPrimoForPeriode(fakturaer, IndexCard.cardId) | currency:'DKK':'':'1.0-0':'da'}}</td>
                </ng-container>
                <td class="text-end">{{(fakturaer | StatistikNetomslaPipe:'igangPrimo') | currency:'DKK':'':'1.0-0':'da' }} </td>
            </tr>

            <tr class="item__tr">
                <td>Igang Ultimo</td>
                <ng-container *ngFor="let IndexCard of laCards">
                    <td class="text-end">{{getUltimoForPeriode(fakturaer, IndexCard.cardId) | currency:'DKK':'':'1.0-0':'da'}}</td>
                </ng-container>
                <td class="text-end">{{(fakturaer | StatistikNetomslaPipe:'igangUltimo') | currency:'DKK':'':'1.0-0':'da' }} </td>
            </tr>
            <tr class="item__tr">
                <td>Total</td>
                <ng-container *ngFor="let IndexCard of laCards">
                    <td class="text-end">{{(getUltimoForPeriode(fakturaer, IndexCard.cardId) +
                        getPrimoForPeriode(fakturaer, IndexCard.cardId)) + getFakturaForPeriode(fakturaer,
                        IndexCard.cardId) |
                        currency:'DKK':'':'1.0-0':'da'}}</td>
                </ng-container>
                <td class="text-end">{{((fakturaer | StatistikNetomslaPipe:'beloeb') + (fakturaer |
                    StatistikNetomslaPipe:'igangPrimo')+ (fakturaer | StatistikNetomslaPipe:'igangUltimo')) |
                    currency:'DKK':'':'1.0-0':'da' }} </td>
            </tr>
        </tbody>
    </table>

    <label *ngIf="selectedYear > 1" class="periodeLabel">Periode: fra {{periode2?.fra | date:'mediumDate':'':'da'}} til
        {{periode2?.til | date:'mediumDate':'':'da'}}</label>
    <table *ngIf="selectedYear > 1" class="table table-hover table-striped table-sm table-frame__body">
        <thead class="fixed-top position-fixed position-sticky">
            <tr>
                <th> LA</th>
                <ng-container *ngFor="let IndexCard of laCards">
                    <th class="text-end">{{IndexCard.fornavn}} {{IndexCard.efternavn}}</th>
                </ng-container>
                <th class="text-end">Total</th>
            </tr>
        </thead>


        <tbody>
            <tr class="item__tr">
                <td>Faktureret i perioden</td>
                <ng-container *ngFor="let IndexCard of laCards">
                    <td class="text-end">{{getFakturaForPeriode(fakturaer2, IndexCard.cardId) |
                        currency:'DKK':'':'1.0-0':'da'}}</td>
                </ng-container>
                <td class="text-end">{{(fakturaer2 | StatistikNetomslaPipe:'beloeb') | currency:'DKK':'':'1.0-0':'da' }}
                </td>
            </tr>

            <tr class="item__tr">
                <td>Igang Primo</td>
                <ng-container *ngFor="let IndexCard of laCards">
                    <td class="text-end">{{getPrimoForPeriode(fakturaer2, IndexCard.cardId) |
                        currency:'DKK':'':'1.0-0':'da'}}</td>
                </ng-container>
                <td class="text-end">{{(fakturaer2 | StatistikNetomslaPipe:'igangPrimo') |
                    currency:'DKK':'':'1.0-0':'da' }}</td>
            </tr>

            <tr class="item__tr">
                <td>Igang Ultimo</td>
                <ng-container *ngFor="let IndexCard of laCards">
                    <td class="text-end">{{getUltimoForPeriode(fakturaer2, IndexCard.cardId) |
                        currency:'DKK':'':'1.0-0':'da'}}</td>
                </ng-container>
                <td class="text-end">{{(fakturaer2 | StatistikNetomslaPipe:'igangUltimo') |
                    currency:'DKK':'':'1.0-0':'da' }}</td>
            </tr>
            <tr class="item__tr">
                <td>Total</td>
                <ng-container *ngFor="let IndexCard of laCards">
                    <td class="text-end">{{(getUltimoForPeriode(fakturaer2, IndexCard.cardId) +
                        getPrimoForPeriode(fakturaer2, IndexCard.cardId)) + getFakturaForPeriode(fakturaer2,
                        IndexCard.cardId) |
                        currency:'DKK':'':'1.0-0':'da'}}</td>
                </ng-container>
                <td class="text-end">{{((fakturaer2 | StatistikNetomslaPipe:'beloeb') + (fakturaer2 |
                    StatistikNetomslaPipe:'igangPrimo')+ (fakturaer2 | StatistikNetomslaPipe:'igangUltimo')) |
                    currency:'DKK':'':'1.0-0':'da' }} </td>
            </tr>
        </tbody>
    </table>



    <label *ngIf="selectedYear > 2" class="periodeLabel">Periode: fra {{periode3?.fra | date:'mediumDate':'':'da'}} til
        {{periode3?.til | date:'mediumDate':'':'da'}}</label>
    <table *ngIf="selectedYear > 2" class="table table-hover table-striped table-sm table-frame__body">
        <thead class="fixed-top position-fixed position-sticky">
            <tr>
                <th> LA</th>
                <ng-container *ngFor="let IndexCard of laCards">
                    <th class="text-end">{{IndexCard.fornavn}} {{IndexCard.efternavn}}</th>
                </ng-container>
                <th class="text-end">Total</th>
            </tr>
        </thead>

        <tbody>
            <tr class="item__tr">
                <td>Faktureret i perioden</td>
                <ng-container *ngFor="let IndexCard of laCards">
                    <td class="text-end">{{getFakturaForPeriode(fakturaer3, IndexCard.cardId) |
                        currency:'DKK':'':'1.0-0':'da'}}</td>
                </ng-container>
                <td class="text-end">{{(fakturaer3 | StatistikNetomslaPipe:'beloeb') | currency:'DKK':'':'1.0-0':'da' }}
                </td>
            </tr>

            <tr class="item__tr">
                <td>Igang Primo</td>
                <ng-container *ngFor="let IndexCard of laCards">
                    <td class="text-end">{{getPrimoForPeriode(fakturaer3, IndexCard.cardId) |
                        currency:'DKK':'':'1.0-0':'da'}}</td>
                </ng-container>
                <td class="text-end">{{(fakturaer3 | StatistikNetomslaPipe:'igangPrimo') |
                    currency:'DKK':'':'1.0-0':'da' }}</td>
            </tr>

            <tr class="item__tr">
                <td>Igang Ultimo</td>
                <ng-container *ngFor="let IndexCard of laCards">
                    <td class="text-end">{{getUltimoForPeriode(fakturaer3, IndexCard.cardId) |
                        currency:'DKK':'':'1.0-0':'da'}}</td>
                </ng-container>
                <td class="text-end">{{(fakturaer3 | StatistikNetomslaPipe:'igangUltimo') |
                    currency:'DKK':'':'1.0-0':'da' }}</td>
            </tr>
            <tr class="item__tr">
                <td>Total</td>
                <ng-container *ngFor="let IndexCard of laCards">
                    <td class="text-end">{{(getUltimoForPeriode(fakturaer3, IndexCard.cardId) +
                        getPrimoForPeriode(fakturaer3, IndexCard.cardId)) + getFakturaForPeriode(fakturaer3,
                        IndexCard.cardId) |
                        currency:'DKK':'':'1.0-0':'da'}}</td>
                </ng-container>
                <td class="text-end">{{((fakturaer3 | StatistikNetomslaPipe:'beloeb') + (fakturaer3 |
                    StatistikNetomslaPipe:'igangPrimo')+ (fakturaer3 | StatistikNetomslaPipe:'igangUltimo')) |
                    currency:'DKK':'':'1.0-0':'da' }} </td>
            </tr>
        </tbody>
    </table>

    <div class="export-section">
        <button class="btn btn-primary" (click)="exportToExcel()">Exporter til Excel</button>
    </div>
</div>
